import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const onboardingActions = createActionGroup({
  source: 'Onboarding',
  events: {
    'Resend Email Verification Start': props<{ userId: string }>(),
    'Resend Email Verification Success': emptyProps(),
    'Resend Email Verification Failure': props<{ error: { message: string } }>(),
  },
});
